<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px; padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.addSuggestionsAndSystemEnhancement')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 pr-0">
            <div class="card card_layout p-4">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.providerName')}}</label>
                                <div class="input-group mb-3">
                                    <input class="form-control" type="text" v-model="provider.name" disabled />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('shared.serviceName')}}</label>
                                <v-select v-model="myService" :items="services" item-text="name" item-value="id" solo
                                    :placeholder="$t('shared.selectService')">
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('shared.title')}}</label>
                                <input class="form-control" type="text" v-model="title" maxlength="30"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 mt-5">
                        <div class="form-group">
                            <label>{{$t('shared.suggestionsAndSystemEnhancement')}}</label>
                            <textarea class="form-control" v-model="suggestionText" maxlength="500" rows="5"></textarea>
                            <small class="form-text text-muted text-right d-block">
                                {{ suggestionText.length }} / 500
                            </small>
                        </div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <div class="form-row justify-content-end align-items-center">
                            <div class="col-auto mx-3">
                                <router-link to="/Dashboard" tag="a"
                                    class="link_secondary">{{$t('shared.back')}}</router-link>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-success px-5 py-2" :disabled="!isValid"
                                    @click="showaddSuggestionDialog">{{$t('shared.submit')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="addSuggestionDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.addInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideddSuggestionDiDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.addSuggestionsAndSystemEnhancementInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideddSuggestionDiDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="addSuggestion">
                                {{$t('shared.Ok')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>